<div mat-dialog-title>
    <h1>{{title}}<div *ngIf="titleSuffix">&nbsp;- {{titleSuffix}}</div></h1>
    <button mat-button [mat-dialog-close]="closeData">
        <mat-icon aria-hidden="false" aria-label="Example home icon">close</mat-icon>
    </button>
</div>
